import * as z from "zod";
import { mutator } from "./mutator";

const registerOAuthAppSchema = z.object({
  id: z.string(),
  name: z.string().min(1).max(120),
  redirectUris: z.array(z.string().min(1).max(2048)).min(1),
});

export const registerOAuthApp = mutator({
  schema: registerOAuthAppSchema,
  resolve: {},
  permissions: {
    none: "compatibility no-op for the retired OAuth app registry",
  },
  fn: () => Promise.resolve(),
});
